import { render, staticRenderFns } from "./InfoBill.vue?vue&type=template&id=ef8d3c24&scoped=true"
import script from "./InfoBill.vue?vue&type=script&lang=js"
export * from "./InfoBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8d3c24",
  null
  
)

export default component.exports